import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.error.cause.js";
import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, vShow as _vShow, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-d2624af6"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  key: 0,
  class: "cms-card-block"
};
const _hoisted_2 = {
  style: {
    "display": "flex",
    "align-items": "center",
    "padding": "0 0 22px 0"
  }
};
const _hoisted_3 = ["checked", "disabled", "onChange"];
const _hoisted_4 = {
  style: {
    "flex": "1",
    "display": "flex",
    "justify-content": "flex-end"
  }
};
const _hoisted_5 = {
  key: 1
};
const _hoisted_6 = {
  class: "cms-card-block"
};
const _hoisted_7 = {
  style: {
    "display": "flex",
    "align-items": "center",
    "padding": "0 0 22px 0"
  }
};
const _hoisted_8 = ["disabled", "checked", "onChange"];
const _hoisted_9 = {
  style: {
    "flex": "1",
    "display": "flex",
    "justify-content": "flex-end"
  }
};
import HeaderSearch from './HeaderSearch.vue';
import MediaInfoItem from './MediaInfoItem/index.vue';
import SubtitleDialog from '../components/SubtitleDialog/index.vue';
import Buttons from '@/components/Buttons/index.vue';
import TagType from '../components/TagType/index.vue';
import { useI18n } from 'vue-i18n';
import { useVodLanguages } from '@/utils/cacheData';
import { getItemByProp, getArrByReduce } from '@/utils/tools';
import { inject, onMounted } from 'vue';
import { elMessage, isEmptyArray } from '@/utils';
import { ElMessageBox } from 'element-plus';
import { validatorNonNull } from '@/utils/validate';
import { getMediaInfoApi } from '@/api/vod';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    programType: {
      type: String,
      default: 'movie'
    },
    mediaName: {
      type: String,
      default: ''
    }
  },

  setup(__props, {
    expose
  }) {
    const props = __props;
    const {
      t
    } = useI18n();
    const dramaValRef = ref();
    const languageValRef = ref();
    const subtitleDialogRef = ref();
    const FormRef = ref();
    const checkedList = ref([]);
    const languageOptions = inject('languageOptions');
    const selectOptions = computed(() => {
      const options = [];
      languageOptions.value.forEach(item => {
        options.push({ ...item,
          disabled: false
        });
      });
      return options;
    });

    const isChecked = index => {
      const idx = checkedList.value.indexOf(index);
      return idx === -1 ? false : true;
    };

    const handleCheckChange = index => {
      const idx = checkedList.value.indexOf(index);
      idx !== -1 ? checkedList.value.splice(idx, 1) : checkedList.value.push(index);
    }; // 已选的语言加上禁用


    const addDisabledForOptions = val => {
      if (!isEmptyArray(val)) {
        let ids = getArrByReduce(val, 'audioLanguage');
        selectOptions.value.forEach(item => {
          item.disabled = ids.includes(item['code']) ? true : false;
        });
      }
    };

    const onChange = (arr, code, newIndex) => {
      const oldIndex = arr.findIndex(item => item.audioLanguage === code.audioLanguage); // 1. move to right side:

      if (newIndex - 1 > oldIndex) {
        // console.log('right');
        let tempArr = [...arr.slice(0, oldIndex), ...arr.slice(oldIndex + 1, newIndex), code, ...arr.slice(newIndex)];
        let newArr = tempArr.map((item, index) => {
          return { ...item,
            sequence: index + 1
          };
        });
        return newArr;
      } // 2. move to left side: 
      else if (newIndex - 1 < oldIndex || newIndex - 1 === oldIndex) {
        // console.log('left');
        let tempArr = [...arr.slice(0, newIndex - 1), code, ...arr.slice(newIndex - 1, oldIndex), ...arr.slice(oldIndex + 1)];
        let newArr = tempArr.map((item, index) => {
          return { ...item,
            sequence: index + 1
          };
        });
        return newArr;
      } else if (newIndex === 1) {
        let cArr = JSON.parse(JSON.stringify(arr));
        cArr.splice(oldIndex, 1);
        let tempArr = [code, ...cArr];
        let newArr = tempArr.map((item, index) => {
          return { ...item,
            sequence: index + 1
          };
        });
        return newArr;
      }
    };

    const getCurrentActive = (arr, key, value) => {
      return arr.findIndex(item => item[key] === value);
    };

    const buttonOptions = reactive({
      visible: false,
      action: 'addDrama',
      config: {
        title: '',
        destroyOnClose: true
      },
      buttonsList: [{
        label: '编辑',
        type: 'success',
        func: () => {
          buttonOptions.config.title = '编辑';
          buttonOptions.action = 'edit';
          buttonOptions.visible = true;
          data.formData.audioLanguage = Tags.value[data.currentActive].audioLanguage;
          data.formData.sequence = Tags.value[data.currentActive].sequence;
        },
        controller: btn => {
          return props.programType === 'movie' ? false : true;
        }
      }, {
        label: '删除',
        type: 'danger',
        func: () => {
          if (props.programType === 'movie') {
            if (checkedList.value.length === 0 || searchConfig.formData.mediaList.length === 1 || searchConfig.formData.mediaList.length === checkedList.value.length) {
              return elMessage('warning', '至少保留一个影片');
            }

            deleteDialogConfig.visible = true;
          } else {
            if (checkedList.value.length === 0 && Tags.value.length === 1) {
              return elMessage('warning', '至少保留一个剧集');
            } else if (checkedList.value.length === Tags.value[data.currentActive].tvEpisodesList.length && Tags.value.length === 1) {
              return elMessage('warning', '至少保留一个剧集');
            } else {
              if (checkedList.value.length === 0 && Tags.value.length > 1) {
                let isReturn = false;
                let msgArr = [];
                Tags.value[data.currentActive].tvEpisodesList.forEach(item => {
                  if (item.releaseStatus === 'online') {
                    isReturn = true;
                    msgArr.push(item.name);
                  }

                  ;
                });

                if (isReturn) {
                  return ElMessageBox.confirm(t('剧集名已上线:', {
                    list: msgArr.join(',')
                  }), t('Warning'), {
                    confirmButtonText: t('确定'),
                    cancelButtonText: t('取消'),
                    type: 'warning'
                  });
                }

                deleteDialogConfig.visible = true;
              } else {
                deleteDialogConfig.visible = true;
              }
            }
          }
        }
      }, {
        label: props.programType === 'movie' ? '添加影片' : '添加剧集',
        type: 'primary',
        func: () => {
          if (props.programType === 'movie') {
            addMediaInfo();
          } else {
            buttonOptions.config.title = '添加剧集';
            data.dramaFormData.dramaValue = '';
            buttonOptions.action = 'addDrama';
            buttonOptions.visible = true;
          }
        }
      }],
      confirm: done => {
        if (buttonOptions.action === 'addDrama') {
          addDramaInfo(done);
        } else if (buttonOptions.action === 'addLanguage') {
          languageValRef.value.mForm.validate(valid => {
            if (valid) {
              data.showLoading = true;
              let addItem = {
                audioLanguage: data.formData.audioLanguage,
                sequence: Number(data.formData.sequence),
                tvEpisodesList: [{
                  name: getMediaName(),
                  sequence: 1,
                  mediaContentList: [{
                    videoCode: 'H264',
                    videoResolution: '240P'
                  }],
                  subtitleList: [{
                    language: '',
                    filePath: ''
                  }]
                }]
              };
              Tags.value.push(addItem);
              Tags.value = onChange(Tags.value, addItem, addItem.sequence);
              data.currentActive = getCurrentActive(Tags.value, 'audioLanguage', addItem.audioLanguage);
              setTimeout(() => {
                buttonOptions.visible = false;
                data.showLoading = false;
                done();
              }, 200);
            } else {
              done();
            }
          });
        } else if (buttonOptions.action === 'edit') {
          languageValRef.value.mForm.validate(valid => {
            if (valid) {
              data.showLoading = true;
              Tags.value[data.currentActive].language = data.formData.audioLanguage;
              Tags.value[data.currentActive].sequence = Number(data.formData.sequence);
              Tags.value = onChange(Tags.value, Tags.value[data.currentActive], Number(data.formData.sequence));
              data.currentActive = getCurrentActive(Tags.value, 'language', data.formData.audioLanguage);
              setTimeout(() => {
                buttonOptions.visible = false;
                data.showLoading = false;
                done();
              }, 200);
            } else {
              done();
            }
          });
        }
      }
    }); // 校验剧集名

    const validatorDrama = (rule, value, callback) => {
      if (value !== 0 && !value) {
        callback(new Error(t('请输入剧集数量')));
      } else if (!/^[1-9]\d*$/.test(value)) {
        callback(new Error(t('请输入大于0的整数')));
      } else if (value > 100) {
        callback(new Error(t('剧集数量不能超过100')));
      } else {
        callback();
      }
    }; // 校验排序


    const validatorSort = (rule, value, callback) => {
      if (value !== 0 && !value) {
        callback(new Error(t('请输入序号')));
      } else if (!/^[1-9]\d*$/.test(value)) {
        callback(new Error(t('请输入大于0的整数')));
      } else {
        callback();
      }
    };

    const data = reactive({
      currentActive: 0,
      languageOptions: [],
      currentMediaItemIndex: 0,
      dramaVal: '',
      languageValue: '',
      showLoading: false,
      addDramaLoading: false,
      formList: [[{
        label: '语言',
        prop: 'audioLanguage',
        widgetType: 'Select',
        required: true,
        list: selectOptions,
        valueKey: 'code',
        filterable: true
      }], [{
        label: '排序',
        prop: 'sequence',
        widgetType: 'input',
        required: true,
        input: (val, dataForm) => {
          dataForm.sequence = dataForm.sequence.replace(/[^\d]/g, '');

          if (buttonOptions.action === 'edit') {
            if (val > Tags.value.length) {
              dataForm.sequence = Tags.value.length;
            }
          } else if (buttonOptions.action === 'addLanguage') {
            if (val > Tags.value.length) {
              dataForm.sequence = Tags.value.length + 1;
            }
          }
        }
      }]],
      formData: {
        audioLanguage: '',
        sequence: ''
      },
      dramaFormList: [[{
        label: '剧集数',
        prop: 'dramaValue',
        widgetType: 'input',
        required: true,
        input: (val, data) => {
          data.dramaValue = data.dramaValue.replace(/[^\d]/g, '');
        }
      }]],
      dramaFormData: {
        dramaValue: ''
      },
      rules: {
        audioLanguage: [{
          required: true,
          message: t('请选择语言'),
          trigger: 'change'
        }],
        sequence: [{
          required: true,
          validator: validatorSort,
          trigger: 'change'
        }],
        dramaValue: [{
          required: true,
          validator: validatorDrama,
          trigger: 'blur'
        }]
      }
    });
    watch(() => data.currentActive, val => {
      checkedList.value = [];
    }); // 获取所有语言

    const getAllLanguages = async () => {
      const res = await useVodLanguages();
      data.languageOptions = res;
      let mediaItem = getItemByProp(searchConfig.formList, 'audioLanguage');
      mediaItem.list = res;
    };

    const finishData = inject('finishData');
    const mediaParams = inject('mediaParams');

    const getMediaName = () => {
      let length = searchConfig.formData.mediaList.length;

      if (length <= 9) {
        length = ' E0' + length;
      } else {
        length = ' E' + length;
      }

      return props.mediaName + length;
    };

    const getFormData = () => {
      //console.log('拿form数据', finishData.value)
      if (finishData.value.mediaList.mediaList && finishData.value.mediaList.mediaList.length > 0) {
        return finishData.value.mediaList;
      }

      return {
        mediaList: [{
          name: props.mediaName,
          audioLanguage: 'en',
          sequence: 1,
          mediaContentList: [{
            videoCode: 'H264',
            videoResolution: '240P',
            playUrl: mediaParams.value ? mediaParams.value.url : ''
          }],
          subtitleList: [{
            language: '',
            filePath: ''
          }]
        }]
      };
    }; // 搜索框配置 JSON.parse(JSON.stringify(finishData.mediaContentList))


    const searchConfig = reactive({
      formData: getFormData(),
      formList: [{
        label: '影片名称',
        prop: 'name',
        widgetType: 'input',
        placeholder: '请输入影片名称',
        rules: [{
          required: true,
          message: '请输入影片名称',
          trigger: 'blur'
        }]
      }, {
        label: '语言',
        prop: 'audioLanguage',
        widgetType: 'Select',
        placeholder: '请选择语言',
        filterable: true,
        valueKey: 'code',
        rules: [{
          required: true,
          message: '请选择语言',
          trigger: 'change'
        }],
        list: languageOptions
      }, {
        label: '排序',
        prop: 'sequence',
        widgetType: 'input',
        maxlength: 4,
        rules: [{
          required: true,
          trigger: 'blur',
          validator: (rules, value, callback) => {
            if (!value) {
              callback(new Error(t('请输入剧集编号')));
            }

            if (searchConfig.formData.mediaList.length > 1) {
              let num = 0;
              searchConfig.formData.mediaList.forEach(item => {
                if (item.sequence == value) {
                  num++;
                }
              });

              if (num > 1) {
                callback(new Error(t('剧集编号不能重复')));
              }
            }

            if (!/^[1-9]\d*$/.test(value)) {
              callback(new Error(t('请输入大于0的整数')));
            }

            callback();
          }
        }],
        input: (val, dataForm) => {
          dataForm.sequence = dataForm.sequence.replace(/[^\d]/g, '');
          searchConfig.formData.mediaList.forEach((item, index) => {
            FormRef.value?.validateField(`mediaList[${String(index)}].sequence`);
          });
        }
      }]
    }); // JSON.parse(sessionStorage.getItem('mediaDramaInfo')) ||

    const dramaConfig = reactive({
      formData: [{
        name: getMediaName(),
        audioLanguage: '',
        sequence: 1,
        mediaContentList: [{
          videoCode: 0,
          type: 1,
          url: ''
        }],
        subtitleList: [{
          language: '',
          filePath: ''
        }]
      }],
      formList: [{
        label: '剧集名称',
        prop: 'name',
        widgetType: 'input',
        placeholder: '请输入剧集名称',
        maxlength: 50,
        rules: [{
          required: true,
          validator: (rule, value, callback) => validatorNonNull(rule, value, callback, '请输入剧集名称'),
          trigger: 'blur'
        }]
      }, {
        label: '剧集编号',
        prop: 'sequence',
        widgetType: 'input',
        maxlength: 4,
        rules: [{
          required: true,
          trigger: 'blur',
          validator: (rules, value, callback) => {
            if (!value) {
              callback(new Error(t('请输入剧集编号')));
            }

            if (Tags.value[data.currentActive].tvEpisodesList.length > 1) {
              let num = 0;
              Tags.value[data.currentActive].tvEpisodesList.forEach(item => {
                if (item.sequence == value) {
                  num++;
                }
              });

              if (num > 1) {
                callback(new Error(t('剧集编号不能重复')));
              }
            }

            if (!/^[1-9]\d*$/.test(value)) {
              callback(new Error(t('请输入大于0的整数')));
            }

            callback();
          }
        }],
        input: (val, dataForm) => {
          dataForm.sequence = dataForm.sequence.replace(/[^\d]/g, '');
          Tags.value[data.currentActive].tvEpisodesList.forEach((item, index) => {
            FormRef.value[data.currentActive]?.validateField(`tvEpisodesList[${String(index)}].sequence`);
          });
        }
      }]
    });
    const dialogConfig = reactive({
      visible: false,
      action: 'add',
      config: {
        title: '添加字幕'
      },
      confirm: () => {
        const {
          selectData
        } = subtitleDialogRef.value.selectTableConfig;

        if (props.programType === 'movie') {
          addSubtitleItem(selectData, searchConfig.formData.mediaList[data.currentMediaItemIndex].subtitleList);
          subtitleDialogRef.value.multipleTable.commonTableRef.clearSelection();
          dialogConfig.visible = false;
        } else {
          addSubtitleItem(selectData, Tags.value[data.currentActive].tvEpisodesList[data.currentMediaItemIndex].subtitleList);
        }

        subtitleDialogRef.value.multipleTable.commonTableRef.clearSelection();
        dialogConfig.visible = false;
      }
    }); // 删除按钮弹框

    const deleteDialogConfig = reactive({
      visible: false,
      action: 'delete',
      config: {
        title: '提示'
      },
      confirm: done => {
        if (props.programType === 'movie') {
          const filterItem = searchConfig.formData.mediaList.filter((data, dataIndex) => {
            return !checkedList.value.includes(dataIndex);
          });
          searchConfig.formData.mediaList = filterItem;
          checkedList.value = [];
          deleteDialogConfig.visible = false;
          setTimeout(() => {
            done();
          }, 500);
        } else {
          if (checkedList.value.length === 0) {
            data.showLoading = true;
            setTimeout(() => {
              Tags.value.splice(data.currentActive, 1);
              data.currentActive = Tags.value.length - 1;
              data.showLoading = false;
              deleteDialogConfig.visible = false;
              checkedList.value = [];
              setTimeout(() => {
                done();
              }, 500);
            }, 200);
          } else {
            data.showLoading = true; // Tags.value[data.currentActive].tvEpisodesList.forEach((item, index) => {
            //     let length = index + 1
            //     if (length < 10) length = '0' + length
            //     item.name = props.mediaName + ' E' + length
            //     item.episode = index + 1
            // })

            if (checkedList.value.length === Tags.value[data.currentActive].tvEpisodesList.length) {
              deleteDialogConfig.visible = false;
              setTimeout(() => {
                data.showLoading = false;
                Tags.value.splice(data.currentActive, 1);
                data.currentActive = Tags.value.length - 1;
                checkedList.value = [];
                setTimeout(() => {
                  done();
                }, 500);
              }, 200);
            } else {
              const filterItem = Tags.value[data.currentActive].tvEpisodesList.filter((data, dataIndex) => {
                return !checkedList.value.includes(dataIndex);
              });
              Tags.value[data.currentActive].tvEpisodesList = filterItem;
              deleteDialogConfig.visible = false;
              setTimeout(() => {
                data.showLoading = false;
                checkedList.value = [];
                setTimeout(() => {
                  done();
                }, 500);
              }, 200);
            }
          }
        }
      }
    }); // 往数组里添加字幕

    const addSubtitleItem = (selectData, subtitleList) => {
      let time = 0;
      selectData.forEach((item, index) => {
        if (time < selectData.length) {
          subtitleList.forEach((subItem, subIndex) => {
            if (!subItem.language && !subItem.filePath && time <= selectData.length) {
              time++;

              if (subtitleList.findIndex(findItem => findItem.filePath === item.filePath) > -1) {
                return;
              } else {
                subtitleList[subIndex] = {
                  language: item.language,
                  filePath: item.filePath // url: item.url,

                };
              }
            } else if (subIndex === subtitleList.length - 1 && time < selectData.length) {
              time++;

              if (subtitleList.findIndex(findItem => findItem.filePath === item.filePath) > -1) {
                return;
              } else {
                subtitleList.push({
                  language: item.language,
                  filePath: item.filePath // url: item.url,

                });
              }
            }
          });
        }
      });
    };

    const Tags = ref(finishData.value.tvSeasonMediaList && finishData.value.tvSeasonMediaList.length > 0 ? finishData.value.tvSeasonMediaList : [{
      audioLanguage: 'en',
      sequence: 1,
      tvEpisodesList: [{
        name: getMediaName(),
        sequence: 1,
        mediaContentList: [{
          videoCode: 'H264',
          videoResolution: '240P',
          playUrl: mediaParams.value ? mediaParams.value.url : ''
        }],
        subtitleList: [{
          language: '',
          filePath: ''
        }]
      }]
    }]);
    watch(() => [...Tags.value], val => {
      if (val && val.length > 0) {
        addDisabledForOptions(val);
      }
    }, {
      immediate: true,
      deep: true
    });
    watch(() => buttonOptions.visible, val => {
      addDisabledForOptions(Tags.value);
    }, {
      immediate: true,
      deep: true
    });
    expose({
      FormRef,
      searchConfig,
      dramaConfig,
      Tags,
      data
    });

    const handleSelectChange = val => {
      const filterItem = data.languageOptions.filter(item => item.label === val)[0];
      filterItem.disabled = true;
    };

    const onTagClick = (item, index) => {
      data.showLoading = true;
      data.currentActive = index;
      setTimeout(() => {
        data.showLoading = false;
      }, 200);
    };

    const handleAddDrama = () => {
      buttonOptions.config.title = '添加';
      buttonOptions.action = 'addLanguage';
      buttonOptions.visible = true; // data.languageValue = ''
      // languageValRef.value && languageValRef.value.clearValidate()

      data.formData.audioLanguage = '';
      data.formData.sequence = '';
    }; // 添加影片


    const addMediaInfo = () => {
      let sequence = searchConfig.formData.mediaList.length;
      searchConfig.formData.mediaList.push({
        name: props.mediaName,
        audioLanguage: '',
        movieId: finishData.value.mediaList.mediaList[0].movieId,
        sequence: sequence + 1,
        mediaContentList: [{
          videoCode: 'H264',
          videoResolution: '240P'
        }],
        subtitleList: [{
          language: '',
          filePath: ''
        }]
      });
    }; // 添加剧集


    const addDramaInfo = done => {
      dramaValRef.value.mForm.validate((valid, err) => {
        if (valid) {
          data.addDramaLoading = true;

          for (let i = 0; i < Number(data.dramaFormData.dramaValue); i++) {
            let length = Tags.value[data.currentActive].tvEpisodesList.length + 1;
            let newMediaName = props.mediaName;

            if (length <= 9) {
              length = ' E0' + length;
            } else {
              length = ' E' + length;
            }

            Tags.value[data.currentActive].tvEpisodesList.push({
              name: newMediaName + length,
              sequence: Tags.value[data.currentActive].tvEpisodesList.length + 1,
              mediaContentList: [{
                videoCode: 'H264',
                videoResolution: '240P'
              }],
              subtitleList: [{
                language: '',
                filePath: ''
              }],
              tvSeasonId: Tags.value[data.currentActive].tvEpisodesList[0].tvSeasonId
            });
          }

          data.addDramaLoading = false;
          buttonOptions.visible = false;
          data.dramaFormData.dramaValue = '';
        } else {
          console.log(err);
        }
      });
      done();
    }; // 搜索字幕


    const searchSubtitle = index => {
      data.currentMediaItemIndex = index;
      dialogConfig.visible = true;
    }; // 影片的搜索字幕


    const searchMediaSubtitle = (tagIndex = 0) => {
      dialogConfig.visible = true;
      data.currentMediaItemIndex = tagIndex;
    };

    const addMedia = index => {
      if (props.programType === 'movie') {
        searchConfig.formData.mediaList[index].mediaContentList.push({
          videoCode: 'H264',
          videoResolution: '240P'
        });
      } else {
        Tags.value[data.currentActive].tvEpisodesList[index].mediaContentList.push({
          videoCode: 'H264',
          videoResolution: '240P'
        });
      }
    };

    const deleteMediaItem = (index, mediaIndex) => {
      console.log('searchConfig.formData', searchConfig.formData);

      if (mediaIndex === 0) {
        if (props.programType === 'movie') {
          if (searchConfig.formData.mediaList[index].mediaContentList.length === 1) {
            searchConfig.formData.mediaList.splice(index, 1); // searchConfig.formData.forEach((item, index) => {
            //     let length = index + 1
            //     if (length < 10) length = '0' + length
            //     item.name = props.mediaName + ' E' + length
            //     item.episode = index + 1
            // })
          } else {
            searchConfig.formData.mediaList[index].mediaContentList.splice(mediaIndex, 1);
          }

          data.currentMediaItemIndex = data.currentMediaItemIndex - 1;
        } else {
          if (Tags.value[data.currentActive].tvEpisodesList[index].mediaContentList.length === 1) {
            Tags.value[data.currentActive].tvEpisodesList.splice(index, 1);
          } else {
            Tags.value[data.currentActive].tvEpisodesList[index].mediaContentList.splice(mediaIndex, 1);
          }

          data.currentMediaItemIndex = data.currentMediaItemIndex - 1;
        }
      } else {
        if (props.programType === 'movie') {
          searchConfig.formData.mediaList[index].mediaContentList.splice(mediaIndex, 1);
        } else {
          Tags.value[data.currentActive].tvEpisodesList[index].mediaContentList.splice(mediaIndex, 1);
        }
      }
    };

    const addSubtitle = index => {
      if (props.programType === 'movie') {
        searchConfig.formData.mediaList[index].subtitleList.push({
          language: '',
          filePath: ''
        });
      } else {
        Tags.value[data.currentActive].tvEpisodesList[index].subtitleList.push({
          language: '',
          filePath: ''
        });
      }
    };

    const deleteSubtitleItem = (index, subtitleIndex) => {
      if (props.programType === 'movie') {
        searchConfig.formData.mediaList[index].subtitleList.splice(subtitleIndex, 1);
      } else {
        Tags.value[data.currentActive].tvEpisodesList[index].subtitleList.splice(subtitleIndex, 1);
      }
    }; // 媒资管理获取回显信息


    const getMediaInfo = async () => {
      data.showLoading = true;

      try {
        let params = {
          url: mediaParams.value.url,
          fileName: mediaParams.value.name
        };
        const res = await getMediaInfoApi(params);

        if (res.code == '0') {
          mediaParams.value.firstTimeGetMediaInfo = true;

          if (props.programType == 'movie') {
            // 单片
            searchConfig.formData[0].language = res.data.language || 'en';
            searchConfig.formData[0].mediaContentList[0].videoCode = res.data.videoCode || 0;
            searchConfig.formData[0].mediaContentList[0].type = res.data.type || 1;
            searchConfig.formData[0].mediaContentList[0].url = mediaParams.value.url || '';
          } else {
            // 剧集
            res.data.episodeName ? Tags.value[0].tvEpisodesList[0].name = res.data.episodeName : '';
            Tags.value[0].language = res.data.language || 'en';
            Tags.value[0].tvEpisodesList[0].episode = res.data.episode || 1;
            Tags.value[0].tvEpisodesList[0].mediaContentList[0].videoCode = res.data.videoCode || 0;
            Tags.value[0].tvEpisodesList[0].mediaContentList[0].type = res.data.type || 1;
            Tags.value[0].tvEpisodesList[0].mediaContentList[0].url = mediaParams.value.url || '';
          }
        }
      } catch (error) {
        console.log(error);
      }

      data.showLoading = false;
    };

    onMounted(() => {
      getAllLanguages();

      if (mediaParams.value && mediaParams.value.id && !mediaParams.value.firstTimeGetMediaInfo) {
        getMediaInfo();
      }
    });
    return (_ctx, _cache) => {
      const _component_MDialog = _resolveComponent("MDialog");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_form = _resolveComponent("el-form");

      const _component_FormTable = _resolveComponent("FormTable");

      const _directive_loading = _resolveDirective("loading");

      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", null, [__props.programType === 'movie' ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(Buttons, {
        class: "header__btns",
        "buttons-list": buttonOptions.buttonsList
      }, null, 8, ["buttons-list"]), _createVNode(_component_MDialog, {
        modelValue: dialogConfig.visible,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => dialogConfig.visible = $event),
        nativeConfig: {
          width: '70%',
          closeOnClickModal: false
        },
        dialogConfig: dialogConfig.config,
        onOnConfirm: dialogConfig.confirm
      }, {
        default: _withCtx(() => [_createVNode(SubtitleDialog, {
          modelValue: dialogConfig.visible,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => dialogConfig.visible = $event),
          ref_key: "subtitleDialogRef",
          ref: subtitleDialogRef,
          programType: __props.programType,
          languageOptions: data.languageOptions,
          formData: searchConfig.formData
        }, null, 8, ["modelValue", "programType", "languageOptions", "formData"])]),
        _: 1
      }, 8, ["modelValue", "dialogConfig", "onOnConfirm"]), _createVNode(_component_el_form, {
        model: searchConfig.formData,
        ref_key: "FormRef",
        ref: FormRef,
        class: "search-form"
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(searchConfig.formData.mediaList, (tagItem, tagIndex) => {
          return _openBlock(), _createElementBlock("div", {
            style: {
              "margin-bottom": "24px"
            },
            key: tagIndex
          }, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", null, [_createElementVNode("input", {
            style: {
              "cursor": "pointer"
            },
            type: "checkbox",
            checked: isChecked(tagIndex),
            disabled: tagItem.releaseStatus == 'online',
            onChange: $event => handleCheckChange(tagIndex)
          }, null, 40, _hoisted_3)]), _createVNode(HeaderSearch, {
            c_index: tagIndex,
            class: "movie-search-input",
            isShowBtns: false,
            disabled: tagItem.releaseStatus == 'online',
            "form-list": searchConfig.formList,
            "form-data": tagItem,
            "program-type": "movie"
          }, {
            customBtn: _withCtx(() => [_createElementVNode("div", _hoisted_4, [_createVNode(_component_el_button, {
              class: "el-button--default cms-op-btn cms-op-btn--blue--border mg-l--24",
              onClick: $event => searchMediaSubtitle(tagIndex)
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('搜索字幕')), 1)]),
              _: 2
            }, 1032, ["onClick"])])]),
            _: 2
          }, 1032, ["c_index", "disabled", "form-list", "form-data"])]), _createVNode(MediaInfoItem, {
            onAddMediaInfo: addMediaInfo,
            onSearchSubtitle: searchMediaSubtitle,
            c_index: tagIndex,
            programType: __props.programType,
            formData: searchConfig.formData.mediaList,
            onAddMedia: addMedia,
            onDeleteMediaItem: deleteMediaItem,
            onAddSubtitle: addSubtitle,
            onDeleteSubtitleItem: deleteSubtitleItem,
            checkedList: checkedList.value
          }, null, 8, ["c_index", "programType", "formData", "checkedList"])]);
        }), 128))]),
        _: 1
      }, 8, ["model"])])) : _createCommentVNode("", true), __props.programType === 'tv_series' ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createVNode(TagType, {
        modelValue: Tags.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => Tags.value = $event),
        "buttons-list": buttonOptions.buttonsList,
        "current-active": data.currentActive,
        onOnTagClick: onTagClick,
        onAddDrama: handleAddDrama,
        "language-options": data.languageOptions,
        onSelectChange: handleSelectChange
      }, null, 8, ["modelValue", "buttons-list", "current-active", "language-options"]), _createElementVNode("div", _hoisted_6, [_createVNode(Buttons, {
        class: "header__btns",
        "buttons-list": buttonOptions.buttonsList
      }, null, 8, ["buttons-list"]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Tags.value, (item, index) => {
        return _withDirectives((_openBlock(), _createBlock(_component_el_form, {
          key: index,
          model: item,
          ref_for: true,
          ref_key: "FormRef",
          ref: FormRef,
          class: "search-form"
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.tvEpisodesList, (tagItem, tagIndex) => {
            return _openBlock(), _createElementBlock("div", {
              style: {
                "margin-bottom": "24px"
              },
              key: tagIndex
            }, [_createElementVNode("div", _hoisted_7, [_createElementVNode("div", null, [_createElementVNode("input", {
              disabled: tagItem.releaseStatus == 'online',
              style: {
                "cursor": "pointer"
              },
              type: "checkbox",
              checked: isChecked(tagIndex),
              onChange: $event => handleCheckChange(tagIndex)
            }, null, 40, _hoisted_8)]), _createVNode(HeaderSearch, {
              disabled: tagItem.releaseStatus == 'online',
              c_index: tagIndex,
              class: "drama-search-input",
              isShowBtns: false,
              "form-list": dramaConfig.formList,
              "form-data": tagItem,
              "program-type": 'tv_series'
            }, {
              customBtn: _withCtx(() => [_createElementVNode("div", _hoisted_9, [_createVNode(_component_el_button, {
                class: "el-button--default cms-op-btn cms-op-btn--blue--border mg-l--24",
                onClick: $event => searchSubtitle(tagIndex)
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('搜索字幕')), 1)]),
                _: 2
              }, 1032, ["onClick"])])]),
              _: 2
            }, 1032, ["disabled", "c_index", "form-list", "form-data"])]), _createVNode(MediaInfoItem, {
              programType: __props.programType,
              formData: item.tvEpisodesList,
              c_index: tagIndex,
              onAddMedia: addMedia,
              onDeleteMediaItem: deleteMediaItem,
              onAddSubtitle: addSubtitle,
              onDeleteSubtitleItem: deleteSubtitleItem
            }, null, 8, ["programType", "formData", "c_index"])]);
          }), 128))]),
          _: 2
        }, 1032, ["model"])), [[_vShow, index === data.currentActive], [_directive_loading, data.showLoading]]);
      }), 128))]), _createVNode(_component_MDialog, {
        modelValue: dialogConfig.visible,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => dialogConfig.visible = $event),
        nativeConfig: {
          width: '70%',
          closeOnClickModal: false
        },
        dialogConfig: dialogConfig.config,
        onOnConfirm: dialogConfig.confirm
      }, {
        default: _withCtx(() => [_createVNode(SubtitleDialog, {
          modelValue: dialogConfig.visible,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => dialogConfig.visible = $event),
          ref_key: "subtitleDialogRef",
          ref: subtitleDialogRef,
          programType: __props.programType,
          languageOptions: data.languageOptions,
          formData: Tags.value[data.currentActive].tvEpisodesList[data.currentMediaItemIndex],
          languageSelect: Tags.value[data.currentActive].language
        }, null, 8, ["modelValue", "programType", "languageOptions", "formData", "languageSelect"])]),
        _: 1
      }, 8, ["modelValue", "dialogConfig", "onOnConfirm"]), _createVNode(_component_MDialog, {
        autoLoading: "",
        modelValue: buttonOptions.visible,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => buttonOptions.visible = $event),
        nativeConfig: {
          width: '600px',
          closeOnClickModal: false
        },
        dialogConfig: buttonOptions.config,
        onOnConfirm: buttonOptions.confirm
      }, {
        default: _withCtx(() => [buttonOptions.action === 'addDrama' ? _withDirectives((_openBlock(), _createBlock(_component_FormTable, {
          key: 0,
          ref_key: "dramaValRef",
          ref: dramaValRef,
          "form-list": data.dramaFormList,
          "form-data": data.dramaFormData,
          rules: data.rules,
          col: ['30%', '70%']
        }, null, 8, ["form-list", "form-data", "rules"])), [[_directive_loading, data.addDramaLoading, void 0, {
          fullscreen: true
        }]]) : _createCommentVNode("", true), buttonOptions.action === 'edit' || buttonOptions.action === 'addLanguage' ? (_openBlock(), _createBlock(_component_FormTable, {
          key: 1,
          ref_key: "languageValRef",
          ref: languageValRef,
          "form-list": data.formList,
          "form-data": data.formData,
          rules: data.rules,
          col: ['30%', '70%']
        }, null, 8, ["form-list", "form-data", "rules"])) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["modelValue", "dialogConfig", "onOnConfirm"])])) : _createCommentVNode("", true)]), _createVNode(_component_MDialog, {
        autoLoading: "",
        modelValue: deleteDialogConfig.visible,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => deleteDialogConfig.visible = $event),
        nativeConfig: {
          width: '600px',
          closeOnClickModal: false
        },
        dialogConfig: deleteDialogConfig.config,
        onOnConfirm: deleteDialogConfig.confirm
      }, {
        default: _withCtx(() => [__props.programType === 'movie' ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, [_createTextVNode(_toDisplayString(_ctx.$t('确认删除勾选影片吗?')), 1)], 64)) : _createCommentVNode("", true), __props.programType === 'tv_series' ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 1
        }, [checkedList.value.length === 0 ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, [_createTextVNode(_toDisplayString(_ctx.$t('确定要删除当前剧集的语言类型及该剧集语言类型下的全部内容？')), 1)], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
          key: 1
        }, [_createTextVNode(_toDisplayString(_ctx.$t('确认删除勾选影片吗?')), 1)], 64))], 64)) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["modelValue", "dialogConfig", "onOnConfirm"])], 64);
    };
  }

});